export default {
  dbi_reuse_page_title_key_games: 'Key Games',
  dbi_reuse_page_sub_title_key_games:
    'Key casual mobile games selected by the Data Science Team. Adjustable via the game filter. Contact <a href="mailto:franzzhao@tencent.com">franzzhao@tencent.com</a> if you have any questions',
  dbi_reuse_page_title_arrows_top_charts: 'Arrows Top Charts',
  dbi_reuse_page_sub_title_arrows_top_charts:
    'Display mobile games classified as Arrows in SensorTower. Adjustable via the Genre filter.',
  dbi_reuse_page_title_narrative_merge2_top_charts: 'Narrative Merge-2 Top Charts',
  dbi_reuse_page_sub_title_narrative_merge2_top_charts:
    'Display mobile games classified as Narrative Merge-2.',
  dbi_reuse_page_title_games_overlap: 'Hypercasual Games Overlap',
  dbi_reuse_page_sub_title_games_overlap:
    "Display the user overlap of mobile games classified as Hypercasual in SensorTower's product model tags. Adjustable via the Product Model filter",
  dbi_reuse_page_title_daily_reports: 'Casual Games Daily Report',
  // Casual Top Charts (SensorTower)
  dbi_reuse_page_title_casual_top_charts_st: 'Casual Games (SensorTower)',

  // Casual Top Charts (App Magic)
  dbi_reuse_page_title_casual_top_charts_am: 'Casual Games (App Magic)',

  // Casual Games Store Ranks
  dbi_reuse_page_title_casual_games_store_ranks: 'Games Store Ranks',
  // Mini-game Rankings
  dbi_reuse_page_title_mini_game_rankings: 'Mini-game Rankings',

  // Mahjong Top Charts
  dbi_reuse_page_title_top_charts_mahjong: 'Mahjong Top Charts',

  // Tab labels (shared)
  dbi_tab_label_casual_hypercasual: 'Casual + Hypercasual',
  dbi_tab_label_casual_hyper_hybrid: 'Casual + Hypercasual + Hybridcasual',
  dbi_tab_label_hypercasual: 'Hypercasual',
  dbi_tab_label_iaa: 'IAA',
  dbi_tab_label_mahjong_am: 'Mahjong - App Magic',
  dbi_tab_label_mahjong_st: 'Mahjong - SensorTower',

  // Tab annotations (SensorTower)
  dbi_tab_annotation_casual_st:
    "Display mobile games classified as Casual, Hypercasual and Hybridcasual in SensorTower's tags. Adjustable via the Product Model filter",
  dbi_tab_annotation_hyper_st:
    "Display mobile games classified as Hypercasual in SensorTower's product model tags. Adjustable via the Product Model filter",
  dbi_tab_annotation_iaa_st:
    'Display mobile hypercasual games classified as IAA titles with low in-app revenue. Adjustable via the Product Model and ARPU filters',
  dbi_tab_annotation_mahjong_st:
    'Display mobile games classified as Mahjong in SensorTower. Adjustable via the Genre, Camera Pov, Product Model, and Theme filter.',

  // Tab annotations (App Magic)
  dbi_tab_annotation_casual_am:
    'Display mobile games classified as Casual and Hypercasual in App Magic’s Super Genres. Adjustable via the Genre filter',
  dbi_tab_annotation_hyper_am:
    'Display mobile games classified as Hypercasual in App Magic’s Super Genres. Adjustable via the Genre filter',
  dbi_tab_annotation_iaa_am:
    'Display mobile casual games classified as IAA titles with low in-app revenue. Adjustable via the Genre and ARPU filters',
  dbi_tab_annotation_mahjong_am:
    'Display mobile games classified as Mahjong in App Magic. Adjustable via the Genre filter.',
};
